import {
  handlePageTitle,
  PMA_STAGES,
} from "containers/pmaOnboarding/services/data.transformers";
import { useTranslation } from "react-i18next";
import PageHeader from "./header";
import { Layout } from "antd";
import { useEffect, useState } from "react";

const { Content } = Layout;
const PageLayout = ({
  children,
  currentStageKey,
  data,
  loading,
  showBackArrow,
  stepStage,
  pmaOnboarding,
  goBack,
}) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="items-center pma-layout !bg-gray--12 max-w-2xl  w-full m-auto flex flex-col h-[100vh]">
      <PageHeader
        title={handlePageTitle({
          data,
          stepStage,
          currentStageKey,
          translate: t,
          name: pmaOnboarding?.name,
        })}
        loading={loading}
        goBack={goBack}
        showBackArrow={showBackArrow}
        isScrolled={isScrolled}
      />
      <div
        className={`w-full max-w-2xl  ${
          ![PMA_STAGES.STAGES].includes(currentStageKey) ? "pt-12" : ""
        }`}
      >
        <Content className="  overflow-auto overflow-x-hidden pb-24">
          {children}
        </Content>
      </div>
    </div>
  );
};
export default PageLayout;
